import { render, staticRenderFns } from "./TrafficForm.vue?vue&type=template&id=33f753a5&scoped=true"
import script from "./TrafficForm.vue?vue&type=script&lang=js"
export * from "./TrafficForm.vue?vue&type=script&lang=js"
import style0 from "./TrafficForm.vue?vue&type=style&index=0&id=33f753a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f753a5",
  null
  
)

export default component.exports